(ns iris.components.switch
 (:require))


(defn switch [checked on-change]
  [:<>
   [:label {:class "switch"
            :style {:vertical-align "middle"
                    :margin-bottom 0}}
    [:input {:type "checkbox"
             :checked checked
             :aria-checked (if checked "true" "false")
             :on-change (fn [e]
                        ;;   (on-input-checkbox-change e edit-enabled (:ruid @form-data))
                          (on-change)
                          )}]
    [:span {:class "slider round"}]]])
